module.exports = __webpack_public_path__ + "static/media/cellular-plan-ios-mweb.aa2a4915.webp";